import { render, staticRenderFns } from "./secondary-kpi-actions-cell.vue?vue&type=template&id=7a960bcc&scoped=true"
import script from "./secondary-kpi-actions-cell.vue?vue&type=script&lang=ts"
export * from "./secondary-kpi-actions-cell.vue?vue&type=script&lang=ts"
import style0 from "./secondary-kpi-actions-cell.vue?vue&type=style&index=0&id=7a960bcc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a960bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a960bcc')) {
      api.createRecord('7a960bcc', component.options)
    } else {
      api.reload('7a960bcc', component.options)
    }
    module.hot.accept("./secondary-kpi-actions-cell.vue?vue&type=template&id=7a960bcc&scoped=true", function () {
      api.rerender('7a960bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formula-step/secondary-kpi-tab/secondary-kpi-actions-cell.vue"
export default component.exports